module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"help":"Ajuda","home":"Início","login":"Entrar","logout":"Sair","orders":"Pedidos","people":"Pessoas","profile":"Perfil","selections":"Seleções","signup":"Cadastrar-se"}}')
  delete Component.options._Ctor
}
